import { httpCommon } from "../helper/http-common";

class LoginService {
  //Login Api
  login(InputData) {
    return httpCommon.post("Login/Login", InputData);
  }
  // Reset API service
  ResetPassword(InputData) {
    return httpCommon.post("Login/ResetPassword", InputData);
  }
  SendResetEmail(InputData) {
    return httpCommon.post("ForgotPassword/RequestReset", InputData);
  }
  ValidateToken(token) {
    return httpCommon.get("ForgotPassword/ValidateToken", {
      params: { token },
    });
  }
  ForgotPassword(InputData) {
    return httpCommon.post("/ForgotPassword/ResetPassword", InputData);
  }
}

const loginService = new LoginService();
export default loginService;
